const TOGGLE_FIELD_ZONE_COLLAPSE = 'TOGGLE_FIELD_ZONE_COLLAPSE';
const SET_FIELD_ZONE_POSSIBLE_SELECTIONS = 'SET_FIELD_ZONE_POSSIBLE_SELECTIONS';
const SET_FIELD_ZONE_SELECTIONS = 'SET_FIELD_ZONE_SELECTIONS';
const CLEAR_FIELD_ZONE_POSSIBLE_SELECTIONS = 'SET_FIELD_ZONE_POSSIBLE_SELECTIONS';
const CLEAR_FIELD_ZONE_SELECTIONS = 'CLEAR_FIELD_ZONE_SELECTIONS';

const INITIAL_STATE = {
  isCollapsed: false,
  possibleSelections: [],
  selections: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TOGGLE_FIELD_ZONE_COLLAPSE:
      return {
        ...state,
        isCollapsed: !state.isCollapsed,
      };
    case SET_FIELD_ZONE_POSSIBLE_SELECTIONS:
      return {
        ...state,
        possibleSelections: [...action.payload],
      };
    case SET_FIELD_ZONE_SELECTIONS:
      return {
        ...state,
        selections: { ...action.payload },
      };
    case CLEAR_FIELD_ZONE_POSSIBLE_SELECTIONS:
      return {
        ...state,
        possibleSelections: [...action.payload],
      };
    case CLEAR_FIELD_ZONE_SELECTIONS:
      return {
        ...state,
        selections: { ...action.payload },
      };
    default:
      return state;
  }
}

export function toggleFieldZoneCollapse() {
  return {
    type: TOGGLE_FIELD_ZONE_COLLAPSE,
  };
}

export function setPossibleSelections(possibleSelections) {
  return {
    type: SET_FIELD_ZONE_POSSIBLE_SELECTIONS,
    payload: possibleSelections,
  };
}

export function setSelections(selections) {
  return {
    type: SET_FIELD_ZONE_SELECTIONS,
    payload: selections,
  };
}

export function clearPossibleSelections() {
  return {
    type: CLEAR_FIELD_ZONE_POSSIBLE_SELECTIONS,
    payload: [],
  };
}

export function clearSelections() {
  return {
    type: CLEAR_FIELD_ZONE_SELECTIONS,
    payload: {},
  };
}

export function clearFieldZoneSelections() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_FIELD_ZONE_POSSIBLE_SELECTIONS,
      payload: [],
    });

    dispatch({
      type: CLEAR_FIELD_ZONE_SELECTIONS,
      payload: {},
    });
  };
}
